import React from "react";
import PICBlank from "../../../../../media/avatars/blank.png";
import PICBoy from "../../../../../media/avatars/001-boy.svg";
import PICGirl from "../../../../../media/avatars/002-girl.svg";
import { openModal } from "../../../../Library/ModalPopUp";

const MyCard = ({ children }) => {
  return (
    <div className="card card-custom gutter-b">
      <div className="card-body py-0">{children}</div>
    </div>
  );
};

const AvaBlank = ({ ...others }) => {
  return <img src={PICBlank} alt="SGU" {...others} />;
};

const AvaBoy = ({ ...others }) => {
  return <img src={PICBoy} alt="SGU" {...others} />;
};

const AvaGirl = ({ ...others }) => {
  return <img src={PICGirl} alt="SGU" {...others} />;
};

const LabelItem = ({ name, value, required = false }) => {
  return (
    <div className="row mb-6">
      <label
        className={`col-lg-5 font-weight-semibold h6 text-muted ${
          required ? "required" : ""
        }`}
      >
        {name}
      </label>
      <div className="col-lg-7">
        <span className="font-weight-bolder fs-6 text-gray-800 h6 text-capitalize">
          {value}
        </span>
      </div>
    </div>
  );
};

const MessageError = ({message}) =>{
    return (
        <div className="text-center">
            <div className="icon-svg">
                <i className="la la-times-circle icon-10x text-danger"></i>
            </div>
            <h3>{message}</h3>

            <div className="my-5">
                <button className="btn btn-lg btn-primary px-10" type="button" onClick={()=>openModal({open:false})}>Ok Got It</button>
            </div>
        </div>
    )
}

const MessageSuccess = ({message}) =>{
    return (
        <div className="text-center">
            <div className="icon-svg">
                <i className="la la-check-circle icon-10x text-primary"></i>
            </div>
            <h3>{message}</h3>

            <div className="my-5">
                <button className="btn btn-lg btn-primary px-10" type="button" onClick={()=>openModal({open:false})}>Ok Got It</button>
            </div>
        </div>
    )
}

export { PICBlank, MyCard, AvaBlank, AvaBoy, AvaGirl, LabelItem, MessageError, MessageSuccess };
